module.exports = __webpack_public_path__ + "img/Villa_Borna_58.420685e9.jpg";